import { getDay, getWeek, setDay, setWeek, subDays, subYears } from 'date-fns';
import type { DateValue } from '../types';

export const previousYearByCalendarWeek = () => {
  const today = new Date();
  today.setHours(12, 0, 0, 0);
  const week = getWeek(today);
  const dayInWeek = getDay(today);

  return setDay(setWeek(subYears(today, 1), week), dayInWeek);
};

export function defaultDateRange(): DateValue {
  const today = new Date();
  today.setHours(12, 0, 0, 0);
  const previousYearByCW = previousYearByCalendarWeek();

  return {
    range: {
      presetValue: 'last_30_days',
      from: subDays(today, 30),
      to: subDays(today, 1),
      presetLabel: 'datepicker.options.main.last.thirty',
      default: true,
    },
    comparison: {
      presetValue: 'previous_year_by_cal_week',
      from: subDays(previousYearByCW, 30),
      to: subDays(previousYearByCW, 1),
      presetLabel: 'datepicker.options.comparison.previous.year.week',
    },
  };
}
